module.exports = "https://static.zego.com/_next/static/images/QuestionMark-3268167536130a3b1ea6e3714821c453.svg";